<template>
  <v-container :class="'test-feedback-card ' + (fromPublic ? 'public-view' : '')" fluid>
    <v-row v-if="!fromPublic" class="d-flex header-controls">
      <p class="header__text" @click="$router.go(-1)"><i class="fa-regular fa-chevron-left"></i>{{ $t('btnBackToTest_TestFeedback') }}
      </p>
      <ShareLinkButton />
    </v-row>
    <v-row align="center" justify="center">
      <!-- Funding Test Feedback !-->
      <v-row align="center" justify="center" style="width:100%;">
        <v-card class="cardContainer" id="confettiable" outlined>
          <v-row justify="end">
            <v-col class="col-cardContainer"></v-col>
            <v-col class="d-flex align-center justify-end p-0 m-0 custom-img second-col" cols="auto">
              <div class="d-flex flex-column logoContainer">
                <v-img :src="$store.state.fundingTest.evaluation.vendorLogoUrl" max-height="37px" position="center" m
                  contain />
                <p v-if="market !== undefined" class="market-paragraph">
                  {{ $t(`summary.market.${market}`) }}
                </p>
              </div>
              <v-divider vertical class="ml-4 mr-4"></v-divider>
              <div class="d-flex flex-column ml-4 mr-4 rightInfo">
                <h2><strong>{{ formatThousands($store.state.fundingTest.evaluation.initialBalance) }}</strong></h2>
                <p>{{ $t(`Step ${this.$store.state.fundingTest.step}`) }}</p>
              </div>
            </v-col>
          </v-row>
          <v-container fluid class="container-custom">
            <v-row :class="status === 'WINNER'
              ? 'winner'
              : status === 'DISQUALIFIED'
                ? 'disqualified'
                : 'abandoned'
              ">
              <v-col class="d-flex align-center justify-start statusContainer">
                <v-icon class="text-icon mr-2">{{
                  getStatusIcon()
                }}</v-icon>
                <h2 class="text-icon">
                  {{ $t(`titles.${$store.state.fundingTest.status}`) }}
                </h2>
              </v-col>
            </v-row>
            <v-row class="row-container">
              <h3 class="text-summary">{{ $t("summary.title") }}</h3>
              <div class="d-flex calendar-div">
                <v-icon small>fa-regular fa-calendar-day</v-icon>
                <p v-html="$t('dateRange', {
                  from: formatDate(
                    new Date($store.state.fundingTest.createdAt)
                  ),
                })
                  " />
                <p class="ml-2"></p>
              </div>
              <div class="d-flex calendar-div">
                <v-icon small>fa-regular fa-calendar-days</v-icon>
                <p v-html="$tc('totalDays', this.activeDays, {
                  days: this.totalDays,
                  to: formatDate(
                    new Date($store.state.fundingTest.finishedAt)
                  ),
                })
                  " />
              </div>
              <div class="d-flex wallet-div">
                <v-icon small>fa-regular fa-wallet</v-icon>
                <p v-html="$t('brokerAccount_TestFeedback', {
                  broker: $store.state.fundingTest.account.brokerName,
                  identifier: $store.state.fundingTest.account.identifier,
                })
                  " />
              </div>
            </v-row>
            <div class="cards-parent-container" @scroll="(e) => updateSliderControlsStatus(e.target)">
              <!--tarjetas-->
              <v-row class="custom-row-card">
                <!-- Primera tarjeta -->
                <v-tooltip top left class="custom-tooltip" v-if="stringDataBalance">
                  <template v-slot:activator="{ on, attrs }">
                    <v-card class="card-custom" v-bind="attrs" v-on="on">
                      <v-card-text>
                        <div class="text-pair">
                          <img src="@/assets/icons/EllipseCalmGreen.svg" alt="Icon" class="icon" />
                          <p class="custom-paragraph">
                            {{ stringDataBalance.firstTitle }}:
                          </p>
                          <h2 class="custom-h2">
                            ${{ stringDataBalance.firstNumber }}
                          </h2>
                        </div>
                        <div class="text-pair">
                          <img src="@/assets/icons/EllipseNewGreen.svg" alt="Icon" class="icon" />
                          <p class="custom-paragraph">
                            {{ stringDataBalance.secondTitle }}:
                          </p>
                          <h2 class="custom-h2">
                            ${{ stringDataBalance.secondNumber }}
                          </h2>
                        </div>
                        <v-progress-linear v-if="seriesBalance.length > 0" :height="14" :color="'var(--v-mainGreen-base)'"
                          :background-color="'#C3FFE3'" :value="seriesBalance[0]" class="custom-progress" />
                      </v-card-text>
                    </v-card>
                  </template>
                  <div class="tooltip">
                    <span class="tooltiptext">
                      {{ stringDataBalance.reachedProfit }}%
                    </span>
                  </div>
                </v-tooltip>

                <!-- Segunda tarjeta -->
                <v-tooltip top left class="custom-tooltip" v-if="!fromPublic && stringDataDrawdownLoss">
                  <template v-slot:activator="{ on, attrs }">
                    <v-card class="card-custom" v-bind="attrs" v-on="on">
                      <v-card-text>
                        <div class="text-pair">
                          <img src="@/assets/icons/EllipseGrey.svg" alt="Icon" class="icon" />
                          <p class="custom-paragraph">
                            {{ stringDataDrawdownLoss.firstTitle }}:
                          </p>
                          <h2 class="custom-h2">
                            ${{ stringDataDrawdownLoss.firstNumber }}
                          </h2>
                        </div>
                        <div class="text-pair">
                          <img src="@/assets/icons/EllipseRed.svg" alt="Icon" class="icon" />
                          <p class="custom-paragraph">
                            {{ stringDataDrawdownLoss.secondTitle }}:
                          </p>
                          <h2 class="custom-h2">
                            ${{ stringDataDrawdownLoss.secondNumber }}
                          </h2>
                        </div>
                        <v-progress-linear v-if="seriesDrawdownLoss.length > 0" :height="14" :color="'#C42A14'"
                          background-color='var(--v-progressBarBackground-base)' :value="seriesDrawdownLoss[0]"
                          class="custom-progress" />
                      </v-card-text>
                    </v-card>
                  </template>
                  <div class="tooltip">
                    <span class="tooltiptext">
                      {{ stringDataDrawdownLoss.reachedDrawdownLoss }}%
                    </span>
                  </div>
                </v-tooltip>

                <!-- Tercera tarjeta -->
                <v-tooltip top left class="custom-tooltip" v-if="stringDataDailyLoss && stringDataDailyLoss.firstTitle">
                  <template v-slot:activator="{ on, attrs }">
                    <v-card class="card-custom" v-bind="attrs" v-on="on">
                      <v-card-text>
                        <div class="text-pair">
                          <img src="@/assets/icons/EllipseGrey.svg" alt="Icon" class="icon" />
                          <p class="custom-paragraph">
                            {{ stringDataDailyLoss.firstTitle }}:
                          </p>
                          <h2 class="custom-h2">
                            ${{ stringDataDailyLoss.firstNumber }}
                          </h2>
                        </div>
                        <div class="text-pair">
                          <img src="@/assets/icons/EllipseRed.svg" alt="Icon" class="icon" />
                          <p class="custom-paragraph">
                            {{ stringDataDailyLoss.secondTitle }}:
                          </p>
                          <h2 class="custom-h2">
                            ${{ stringDataDailyLoss.secondNumber }}
                          </h2>
                        </div>
                        <v-progress-linear v-if="seriesDailyLoss.length > 0" :height="14" :color="'#C42A14'"
                          background-color="var(--v-progressBarBackground-base)" :value="seriesDailyLoss[0]"
                          class="custom-progress" />
                      </v-card-text>
                    </v-card>
                  </template>
                  <div class="tooltip">
                    <span class="tooltiptext">
                      {{ stringDataDailyLoss.reachedDailyLoss }}%
                    </span>
                  </div>
                </v-tooltip>
              </v-row>
            </div>
            <div class="slider-controls">
              <button @click="scrollContainer(false)" class="prev-btn">
                <i class="fa-regular fa-chevron-left"></i>
              </button>
              <button @click="scrollContainer(true)" class="next-btn">
                <i class="fa-regular fa-chevron-right"></i>
              </button>
            </div>
            <RulesOverview class="rules-overview-outer" v-if="!fromPublic" :collapsed="true" />
            <div :class="`${status === 'WINNER'
              ? 'winner'
              : status === 'DISQUALIFIED'
                ? 'disqualified'
                : 'abandoned'
              } actions`">
              <div v-if="fromPublic" class="buttons-container">
                <!-- NewPoweredBy a la izquierda -->
                <NewPoweredBy />
                <!-- Botón de registro y enlace de inicio de sesión a la derecha -->
                <div class="create-account-container">
                  <button class="button-get-challenged" @click="$router.push('/register')">
                    <v-icon class="icon-Restart">fa-regular fa-arrow-up-right-from-square</v-icon>
                    {{ $t("btnCreateAcc") }}
                  </button>
                  <p class="login-paragraph">
                    {{ $t("alreadyHasAcc") }}
                    <a href="https://app.swiset.com/" target="_blank" class="login-link">
                      {{ $t("login_TestFeedback") }}
                    </a>
                  </p>
                </div>
              </div>
              <v-row v-if="!fromPublic" class="d-flex align-center">
                <button class="button-Restart" @click="restartTest">
                  <v-icon class="mr-2 icon-Restart">fa-regular fa-circle-play</v-icon>
                  {{ $t("btnRestart") }}
                </button>
              </v-row>
              <span v-if="!fromPublic && getChallengeUrl" class="or-text">{{ $t("or") }}</span>
              <v-row v-if="!fromPublic && getChallengeUrl" class="d-flex align-center">
                <button class="button-get-challenged" @click="redirect">
                  <v-icon class="mr-2 icon-Restart">fa-regular fa-arrow-up-right-from-square</v-icon>
                  {{ $t("btnGetChallenge") }}
                </button>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
import Repository from "../../../../repositories/funding";
import { mapMutations } from "vuex";
import RulesOverview from "@/views/Funding/Simulation/components/RulesOverview";
import ShareLinkButton from "@/views/Funding/Simulation/components/ShareLinkButton.vue";
import VueConfetti from "vue-confetti";
import NewPoweredBy from "@/components/NewPoweredBy.vue";
import Vue from "vue";

Vue.use(VueConfetti);

export default {
  name: "TestFeedback",
  components: {
    RulesOverview,
    ShareLinkButton,
    NewPoweredBy,
  },
  props: {
    testId: Number,
    market: String,
    fromPublic: Boolean,
  },
  data() {
    return {
      status: "",
      winner: false,
      disqualified: false,
      overlayLoadingDetails: false,
      months: [],
      totalDays: 0,
      isMobile: window.innerWidth <= 600,
      propLinks: [
        {
          name: "Earn2Trade",
          url: "https://www.earn2trade.com/es?a_pid=swiset"
        },
        {
          name: "Uprofit",
          url: "https://www.uprofit.com/?a_aid=swiset"
        },
        {
          name: "The Trading Pit",
          url: "https://www.thetradingpit.com/es/challenges-overview?ref=ytm4nzd5"
        }
      ],
      getChallengeUrl: undefined,

      // Confetti
      confettiOptions: {
        defaultColors: ["PaleGreen", "Gold", "lightblue"],
        defaultDropRate: 6,
        defaultSize: 5,
        windSpeedMax: 0,
        particlesPerFrame: 1,
      },
      // Main Stats
      stringDataBalance: {
        firstTitle: "",
        firstNumber: 0,
        secondTitle: "",
        secondNumber: 0,
      },
      stringDataDailyLoss: {
        firstTitle: "",
        firstNumber: 0,
        secondTitle: "",
        secondNumber: 0,
        reachedDailyLoss: "0.0",
      },
      stringDataDrawdownLoss: {
        firstTitle: "",
        firstNumber: 0,
        secondTitle: "",
        secondNumber: 0,
        reachedDrawdownLoss: "0.0",
      },
      seriesBalance: [0],
      seriesDailyLoss: [0],
      seriesDrawdownLoss: [0],
    };
  },
  async mounted() {
    await this.init();
    if (window.innerWidth <= 768) {
      this.updateSliderControlsStatus(document.querySelector('.test-feedback-card .cards-parent-container'));
    }
  },
  destroyed() {
    this.$confetti.stop();
  },
  methods: {
    ...mapMutations(["setFundingTest"]),
    async init() {
      this.getMonths();
      this.overlayLoadingDetails = true;
      if (!this.fromPublic && !window.sessionStorage.getItem("fromPublic")) {
        let testId =
          this.testId !== undefined
            ? this.testId
            : this.$store.state.fundingTest.id;

        await Repository.fundingTestOverview(testId).then(async (response) => {
          if (response.status < 400) {
            this.overlayLoadingDetails = false;
            await this.setFundingTest(response.data);
            this.status = this.$store.state.fundingTest.status;
            if (this.status === "WINNER") {
              this.$confetti.start(this.confettiOptions);
            }
            this.calculateDays();
            this.processChartData();
          }
        });
        this.getChallengeUrl = this.$store.state.fundingTest.evaluation.vendorMainWebsite;

      } else {
        this.market = this.$store.state.fundingTest.market;
        this.fromPublic = true;
        window.sessionStorage.setItem("fromPublic",true);
        this.status = this.$store.state.fundingTest.status;
        if (this.status === "WINNER") {
          this.$confetti.start(this.confettiOptions);
        }
        this.calculateDays();
        this.processChartData();
      }
      this.overlayLoadingDetails = false;
    },
    calculateDays() {
      let Difference_In_Time_Total =
        new Date().getTime() -
        new Date(this.$store.state.fundingTest.createdAt).getTime();
      this.totalDays = Math.floor(
        Difference_In_Time_Total / (1000 * 3600 * 24)
      );
    },
    getMonths() {
      this.months = [
        this.$t("months.jan"),
        this.$t("months.feb"),
        this.$t("months.mar"),
        this.$t("months.apr"),
        this.$t("months.may"),
        this.$t("months.jun"),
        this.$t("months.jul"),
        this.$t("months.aug"),
        this.$t("months.sep"),
        this.$t("months.oct"),
        this.$t("months.nov"),
        this.$t("months.dec"),
      ];
    },
    getStatusIcon() {
      switch (this.$store.state.fundingTest.status) {
        case "WINNER":
          return "fa-trophy";
        case "DISQUALIFIED":
        case "PAUSED":
          return "fa-triangle-exclamation";
        default:
          return "fa-running";
      }
    },
    processChartData() {
      // Target
      let totalProfit = Math.abs(
        Number(this.$store.state.fundingTest.evaluation.initialBalance) -
        Number(this.$store.state.fundingTest.evaluation.target)
      );
      let reachedProfit =
        (Number(this.$store.state.fundingTest.currentProfit) / totalProfit) *
        100;
      this.stringDataBalance = {
        firstTitle: this.$t("target.targetTitle"),
        firstNumber:
          Number(this.$store.state.fundingTest.evaluation.target) -
          Number(this.$store.state.fundingTest.evaluation.initialBalance),
        secondTitle: this.$t("target.currentProfitTitle"),
        secondNumber: Number(this.$store.state.fundingTest.currentProfit),
        reachedProfit: reachedProfit.toFixed(1), // Agregar el porcentaje con dos decimales
      };
      this.seriesBalance = [reachedProfit];

      // Daily Loss
      let ruleStatusForDailyLoss =
        this.$store.state.fundingTest.ruleStatuses.find(
          (ruleStatus) => ruleStatus.rule === "MAX_DAILY_LOSS"
        );
      if (ruleStatusForDailyLoss !== undefined) {
        let reachedDailyLoss =
          (Math.abs(ruleStatusForDailyLoss.currentValue) /
            Math.abs(Number(ruleStatusForDailyLoss.referenceValue))) *
          100;
        this.stringDataDailyLoss = {
          firstTitle: this.$t("dailyLoss.dailyLossTitle"),
          firstNumber: Math.abs(Number(ruleStatusForDailyLoss.referenceValue)),
          secondTitle: this.$t("dailyLoss.todayLossTitle"),
          secondNumber: Math.abs(Number(ruleStatusForDailyLoss.currentValue)),
          reachedDailyLoss: reachedDailyLoss.toFixed(1),
        };
        this.seriesDailyLoss = [reachedDailyLoss];
      }

      // Drawdown Loss
      let ruleStatusForDrawdownLoss =
        this.$store.state.fundingTest.ruleStatuses.find(
          (ruleStatus) => ruleStatus.rule === "MAX_DRAWDOWN"
        );
      if (ruleStatusForDrawdownLoss !== undefined) {
        let reachedDrawdownLoss =
          (Math.abs(ruleStatusForDrawdownLoss.currentValue) /
            Math.abs(Number(ruleStatusForDrawdownLoss.referenceValue))) *
          100;
        this.stringDataDrawdownLoss = {
          firstTitle: this.$t("drawdownLoss.drawdownTitle"),
          firstNumber: Math.abs(
            Number(ruleStatusForDrawdownLoss.referenceValue)
          ),
          secondTitle: this.$t("drawdownLoss.currentTotalLossTitle"),
          secondNumber: Math.abs(
            Number(ruleStatusForDrawdownLoss.currentValue)
          ),
          reachedDrawdownLoss: reachedDrawdownLoss.toFixed(1),
        };
        this.seriesDrawdownLoss = [reachedDrawdownLoss];
      }
    },
    formatNumber(number) {
      if (number >= 1000) {
        const formattedNumber = (number / 1000).toFixed(1);
        return formattedNumber.endsWith(".0")
          ? formattedNumber.slice(0, -2) + "k"
          : formattedNumber + "k";
      }
      return number;
    },
    getShortDate(date) {
      return `${this.months[date.getMonth()]} ${date.getDate()}`;
    },
    formatDate(date) {
      return `${this.getShortDate(date)} - ${date.getFullYear()} `;
    },
    restartTest() {
      this.$router.push({
        name: "funding-simulation-home",
        params: { createNew: true },
      });
    },
    goToVendor() {
      window.open(this.$store.state.fundingTest.evaluation.vendorMainWebsite);
    },
    backToTest() {
      this.$router.push({ name: "funding-simulation-home" });
    },
    scrollContainer(right) {
      let container = document.querySelector('.test-feedback-card .cards-parent-container');

      if (window.innerWidth <= 768) {
        container.scrollBy(right ? 300 : -300, 0);
      } else {
        container.scrollBy(right ? 300 : -300, 0);
      }
    },
    updateSliderControlsStatus(container) {
      let a = container.scrollLeft;
      let b = container.scrollWidth - container.clientWidth;
      //Scroll percentage (0-1)
      let c = a / b;
      if (c == 0) {
        container.parentElement.querySelector(".prev-btn").setAttribute("disabled", "disabled");
        container.parentElement.querySelector(".next-btn").removeAttribute("disabled");
      }
      else if (c == 1) {
        container.parentElement.querySelector(".next-btn").setAttribute("disabled", "disabled");
        container.parentElement.querySelector(".prev-btn").removeAttribute("disabled");
      } else if (isNaN(c)) {
        container.parentElement.querySelector(".next-btn").setAttribute("disabled", "disabled");
        container.parentElement.querySelector(".prev-btn").setAttribute("disabled", "disabled");
      } else {
        container.parentElement.querySelector(".next-btn").removeAttribute("disabled", "disabled");
        container.parentElement.querySelector(".prev-btn").removeAttribute("disabled", "disabled");
      }
    },
    redirect() {
      window.open(this.getChallengeUrl, "_blank");
    },
    formatThousands(num, digits) {
      const lookup = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "G" },
        { value: 1e12, symbol: "T" },
        { value: 1e15, symbol: "P" },
        { value: 1e18, symbol: "E" }
      ];
      const regexp = /\.0+$|(?<=\.[0-9]*[1-9])0+$/;
      const item = lookup.findLast(item => num >= item.value);
      return item ? (num / item.value).toFixed(digits).replace(regexp, "").concat(item.symbol) : "0";
    }

  },
};
</script>



<style lang="scss">
@import "src/global";

.test-feedback-card {
  @media (min-width: 769px) {
    margin-top: 10px;
  }

  @media (max-width: 768px) {
    padding: 50px 25px;
  }

  .header-controls {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
    align-items: center;

    @media (max-width: 768px) {
      max-width: unset;
    }

    p {
      color: #9A9A9A;
      font-family: "Avenir", sans-serif;

      @media (max-width: 768px) {
        font-size: 14px;
      }

      &:hover {
        cursor: pointer;
      }

      i {
        margin-right: 10px;
      }
    }
  }

  .logoContainer {

    .market-paragraph {
      color: #9A9A9A;
      font-size: 16px;
    }

    @media (max-width: 768px) {
      padding: 28px 17px;
      width: 500px;

      .market-paragraph {
        font-size: 14px;
        color: #9A9A9A;
      }
    }
  }

  .v-divider {
    border-color: #9A9A9A;
  }

  .rightInfo {
    align-items: center;

    @media (max-width: 768px) {
      width: 500px;

      h2 {
        font-size: 20px;
      }

      p {
        font-size: 16px;
      }
    }

  }

  .calendar-div {
    align-items: center;
    margin-bottom: 20px;

    p {
      margin: 0;
      margin-left: 10px;
      text-align: start;
      font-size: 16px;

      @media (max-width: 768px) {
        font-size: 14px;
      }
    }
  }

  .wallet-div {
    align-items: center;

    p {
      margin: 0;
      margin-left: 10px;
      text-align: start;
      font-size: 16px;

      @media (max-width: 768px) {
        font-size: 14px;
      }
    }
  }

  .cards-parent-container {

    margin-top: 40px;
    margin-bottom: 40px;
    width: 100%;

    @media (max-width: 768px) {
      -ms-overflow-style: none;
      scrollbar-width: none;
      scroll-behavior: smooth;
      overflow-x: scroll;
      margin-top: 20px;
      margin-bottom: 20px;

      &::-webkit-scrollbar {
        display: none;
      }

    }

    .custom-row-card {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); // Adjust 200px as needed
      gap: 65px; // Adjust spacing between cards as needed

      @media (max-width: 768px) {
        overflow: auto;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        -ms-overflow-style: none;
        scrollbar-width: none;
        scroll-behavior: smooth;
        width: fit-content;
        gap: 0px;

        &::-webkit-scrollbar {
          display: none;
        }

        .card-custom {
          width: calc(60vw - 15px);
          margin-right: 15px;

          .v-card__text {
            padding: 0;

            .text-pair {
              p {
                font-size: 12px;
                text-align: start;
              }

              h2 {
                font-size: 20px;
              }
            }

            .v-progress-linear {
              margin-bottom: 0;
            }
          }
        }
      }

      .card-custom {
        border: 1px solid #9a9a9a;
        border-radius: 10px;

        .v-card__text {
          .text-pair {
            h2 {
              margin-left: auto;
            }
          }

          .v-progress-linear {
            .v-progress-linear__background {
              background-color: #eee !important;
              border-color: #eee !important;
              opacity: 1 !important;
              border-radius: 20px !important;
            }

            .v-progress-linear__buffer {
              background-color: #eee !important;
            }

            .v-progress-linear__determinate {
              border-radius: 20px !important;
            }
          }

        }
      }

    }

  }

  .slider-controls {
    display: none;
    flex-direction: row;
    width: 100%;
    justify-content: flex-end;
    margin-top: 20px;

    @media (max-width: 768px) {
      display: flex;
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      outline: 0;
      margin: 0px 10px;
      width: 10px;
      height: 10px;
      background: var(--v-mainGreen-base);
      padding: 15px;

      &.next-btn {
        margin-right: 0;
      }

      i {
        color: #000;
      }

      &:disabled {
        background: var(--v-mainBlack-base);
        opacity: 0.1;

        i {
          color: var(--v-mainWhite-base);
        }
      }
    }
  }

  .statusContainer {
    padding: 0;


    @media (min-width: 769px) {
      margin-top: -38px;
      margin-bottom: 25px;
    }

    @media (max-width: 1190px) {
      margin-top: 25px;
    }

    margin-left: auto;
    margin-bottom: 25px;

    @media (max-width: 768px) {
      h2 {
        font-size: 20px;
      }

      .v-icon {
        font-size: 20px;
        margin: 0 !important;
      }

    }
  }

  .cardContainer {
    width: 80%;
    border: 1px solid #9A9A9A;
    border-radius: 10px;

    @media (min-width: 769px) {
      padding-left: 48px;
    }


    @media (max-width: 768px) {
      width: 100%;
      border-radius: 15px;
      text-align: center;
    }

    .col-cardContainer {
      @media (min-width: 769px) {
        padding-top: 104px;
      }

      @media (max-width: 768px) {
        padding: 0;
      }
    }

    .cardContainer-container {
      @media (min-width: 769px) {
        padding-right: 48px;
        padding-bottom: 0;
      }
    }
  }

  .rules-overview-outer {
    .rules-container {
      display: none;
    }
  }

  .row-container {
    display: flex;
    flex-direction: column
  }

  .v-responsive__content {
    width: 0 !important;
  }

  .container-custom {
    padding: 0;

    @media (min-width: 769px) {
      padding-right: 48px;
    }

    @media (max-width:768px) {
      padding: 0 12px;
    }
  }

  .custom-img {
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 0;
    border-left: 1px solid var(--Grey-Medium, #9a9a9a);
    border-bottom: 1px solid var(--Grey-Medium, #9a9a9a);

    @media (max-width: 768px) {
      border-left: none;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      border-bottom: 1px solid var(--Grey-Medium, #9a9a9a);
      width: 100%; // Asegura que el borde cubra toda la anchura
      box-sizing: border-box; // Incluye el borde en el ancho total
    }
  }

  .text-summary {
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    margin-bottom: 15px;

    @media (max-width: 768px) {
      display: none;
    }
  }

  .white-content {
    color: $white-color;
  }

  .cardContainer {
    width: 80%;
    border: 1px solid #9A9A9A;

    @media (max-width: 786px) {
      width: 100%;
      border-radius: 15px;
      text-align: center;
    }
  }


  .winner {
    .border {
      border-color: var(--v-mainGreen-base);
    }

    .text-icon {
      color: var(--v-mainGreen-base);
      font-weight: bold;

      @media (max-width: 768px) {
        margin: auto;
      }
    }

    .button {
      border-color: var(--v-mainGreen-base);
      color: $white-color !important;
    }
  }

  .disqualified {
    .border {
      border-color: $dark-red;
    }

    .text-icon {
      color: $dark-red;
      font-weight: bold;

      @media (max-width: 768px) {
        margin: auto;
      }
    }

    .button {
      border-color: $dark-red;
      color: $white-color !important;
    }
  }

  .abandoned {
    .border {
      border-color: #FF8933;
    }

    .text-icon {
      color: #FF8933;
      font-weight: bold;

      @media (max-width: 768px) {
        margin: auto;
      }
    }

    .button {
      border-color: $dark-red;
    }
  }

  .card-custom {
    display: flex;
    padding: 15px;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 10px;
    border: 1px solid var(--Grey-Medium, #9a9a9a);
    box-shadow: none !important;
  }

  .custom-row-card {
    justify-content: space-between;
  }

  .custom-progress {
    margin-top: 20px;
    border-radius: 10px;
    overflow: hidden;
  }

  .icon {
    width: 8px;
    height: 8px;
    margin-right: 8px;
  }

  .text-pair {
    display: flex;
    align-items: center;

    p {
      margin-right: 10px;
    }
  }

  .custom-paragraph {
    font-size: 14px;

    @media (max-width: 768px) {
      font-size: 14px;
    }
  }

  .custom-h2 {
    text-align: right;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
  }

  .button-get-challenged {
    @media (max-width: 768px) {
      width: 100%;
      padding: unset;
      font-size: 14px;
    }

    .v-icon {
      margin-right: 10px;
      font-size: 14px;
    }

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background: var(--v-mainGreen-base);
    border: 1px solid transparent;
    outline: 0;
    border-radius: 10px;
    font-family: "Avenir",
    sans-serif;
    font-weight: bold;
  }

  .button-Restart {
    @media (max-width: 768px) {
      width: 100%;
      padding: unset;
      font-size: 12px;
    }

    .v-icon {
      margin-right: 10px;
      font-size: 16px;
    }

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background: var(--v-cardHeaderBackground-base);
    border: 1px solid transparent;
    outline: 0;
    border-radius: 10px;
    font-family: "Avenir",
    sans-serif;
    font-weight: bold;
  }

  .register-button {
    border-radius: 8px !important;
    background-color: var(--v-mainGreen-base) !important;

    &:hover {
      background-color: var(--v-mainGreen-base) !important;
    }
  }

  .bold-text {
    font-weight: bold;
  }

  .actions {
    margin-top: 40px;
    margin-bottom: 36px;

    @media (min-width: 769px) {
      display: flex;
      width: fit-content;
      margin-left: auto;
    }

    @media (max-width: 768px) {
      margin: 0;
      margin-top: 25px;
      margin-bottom: 30px;
    }

    button {
      padding: 15px 20px;
    }

    .or-text {
      font-family: "Avenir", sans-serif;
      font-size: 16px;
      margin-top: 5px;
      margin-bottom: 5px;
      display: flex;
      align-items: center;
      margin-left: 30px;
      margin-right: 30px;

      @media (max-width: 768px) {
        justify-content: center;
      }
    }

    .login-paragraph {
      margin-top: 8px;
      font-size: 16px;

      .login-link {
        text-decoration: underline;
        color: var(--v-mainGreen-base);
      }

      @media (max-width: 768px) {
        font-size: 14px;
      }

    }
  }

  &.public-view {
    .actions {
      width: 100%;

      .buttons-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        @media (min-width: 769px) {
          .button-get-challenged {
            margin-left: auto;
          }

          .login-paragraph {
            text-align: end;
          }
        }

        @media (max-width: 768px) {
          flex-direction: column;

          .create-account-container {
            display: none;
            margin-top: 30px;
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
<i18n>
 {
  "en": {
    "titles": {
      "WINNER": "You achieve the simulation target",
      "DISQUALIFIED": "You failed this simulation",
      "ABANDONED": "You abandoned this simulation",
      "PAUSED": "You paused this simulation"
    },
    "target": {
      "targetTitle": "Target balance",
      "currentProfitTitle": "Current balance"
    },
    "dailyLoss": {
      "dailyLossTitle": "Max. Daily Loss",
      "todayLossTitle": "Current daily loss"
    },
    "drawdownLoss": {
      "drawdownTitle": "Max. Drawdown",
      "currentTotalLossTitle": "Current total loss"
    },
    "summary": {
      "title": "Summary",
      "market": {
        "Forex": "Forex evaluation ",
        "Futures": "Futures evaluation"
      }
    },
    "months": {
      "jan" : "Jan",
      "feb" : "Feb",
      "mar" : "Mar",
      "apr" : "Apr",
      "may" : "May",
      "jun" : "Jun",
      "jul" : "Jul",
      "aug" : "Aug",
      "sep" : "Sep",
      "oct" : "Oct",
      "nov" : "Nov",
      "dec" : "Dec"
    },
    "dateRange": "<b>Started at: </b>{from} ",
    "totalDays": "<b>End at: </b> {to} (you had {days} days of evaluation)",
    "brokerAccount": "<b>Participating account: </b> {broker} {identifier}",
    "btnRestart": "Start new simulation",
    "btnGetChallenge": "Get this challenge",
    "btnCreateAcc": "Create Account",
    "btnGoToVendor": "Go to a real evaluation in {vendor}",
    "btnBackToTest": "Back to my simulations",
    "or":"or",
    "alreadyHasAcc": "If you already have a Swiset account",
    "login": "login"
  },
  "es": {
    "titles": {
      "WINNER": "Haz logrado esta simulación",
      "DISQUALIFIED": "Has fallado en esta simulación",
      "ABANDONED": "Abandonaste esta simulación"
    },
    "target": {
      "targetTitle": "Rendimiento Objetivo",
      "currentProfitTitle": "Rendimiento Actual"
    },
    "dailyLoss": {
      "dailyLossTitle": "Límite Diario de Pérdida",
      "todayLossTitle": "Pérdida Hoy"
    },
    "drawdownLoss": {
      "drawdownTitle": "Máximo Drawdown",
      "currentTotalLossTitle": "Drawdown"
    },
    "summary": {
      "title": "Resumen",
      "market": {
        "Forex": "Simulación en Forex",
        "Futures": "Simulación en Futuros"
      }
    },
    "months": {
      "jan" : "Ene",
      "feb" : "Feb",
      "mar" : "Mar",
      "apr" : "Abr",
      "may" : "May",
      "jun" : "Jun",
      "jul" : "Jul",
      "aug" : "Aug",
      "sep" : "Sep",
      "oct" : "Oct",
      "nov" : "Nov",
      "dec" : "Dec"
    },
    "dateRange": "<b>Comenzó el: </b>{from} ",
    "totalDays": "<b>Terminó el: </b> {to} (tuviste {days} días de evaluación)",
    "brokerAccount": "<b>Participaste con: </b> {identifier} - {broker} ",
    "btnRestart": "Comenzar otra prueba",
    "btnGetChallenge": "Obtener prueba",
    "btnCreateAcc": "Crear Cuenta",
    "btnGoToVendor": "Haz una prueba real en {vendor}",
    "btnBackToTest": "Volver a mis simulaciones",
    "or":"ó",
    "alreadyHasAcc": "Si ya tienes una cuenta en Swiset",
    "login": "ingresa"
  },
  "pt": {
    "titles": {
      "WINNER": "Você atingiu o objetivo da simulação",
      "DISQUALIFIED": "Você falhou nesta simulação",
      "ABANDONED": "Você abandonou esta simulação",
      "PAUSED": "Você pausou esta simulação"
    },
    "target": {
      "targetTitle": "Saldo alvo",
      "currentProfitTitle": "Saldo atual"
    },
    "dailyLoss": {
      "dailyLossTitle": "Perda diária máxima",
      "todayLossTitle": "Perda diária atual"
    },
    "drawdownLoss": {
      "drawdownTitle": "Redução máxima",
      "currentTotalLossTitle": "Perda total atual"
    },
    "summary": {
      "title": "Resumo",
      "market": {
        "Forex": "Avaliação de Forex",
        "Futures": "Avaliação de Futuros"
      }
    },
    "months": {
      "jan": "Jan",
      "feb": "Fev",
      "mar": "Mar",
      "apr": "Abr",
      "may": "Mai",
      "jun": "Jun",
      "jul": "Jul",
      "aug": "Ago",
      "sep": "Set",
      "oct": "Out",
      "nov": "Nov",
      "dec": "Dez"
    },
    "dateRange": "<b>Iniciado em: </b>{from} ",
    "totalDays": "<b>Encerrado em: </b>{to} (você teve {days} dias de avaliação)",
    "brokerAccount": "<b>Conta participante: </b>{broker} {identifier}",
    "btnRestart": "Iniciar nova simulação",
    "btnGetChallenge": "Obter este desafio",
    "btnCreateAcc": "Criar conta",
    "btnGoToVendor": "Ir para uma avaliação real em {vendor}",
    "btnBackToTest": "Voltar para minhas simulações",
    "or": "ou",
    "alreadyHasAcc": "Se você já possui uma conta Swiset",
    "login": "entrar"
  },
  "th": {
    "titles": {
      "WINNER": "คุณบรรลุเป้าหมายของการจำลองนี้",
      "DISQUALIFIED": "คุณล้มเหลวในการจำลองนี้",
      "ABANDONED": "คุณละทิ้งการจำลองนี้",
      "PAUSED": "คุณหยุดการจำลองนี้ชั่วคราว"
    },
    "target": {
      "targetTitle": "ยอดคงเหลือเป้าหมาย",
      "currentProfitTitle": "ยอดคงเหลือปัจจุบัน"
    },
    "dailyLoss": {
      "dailyLossTitle": "ขาดทุนรายวันสูงสุด",
      "todayLossTitle": "ขาดทุนรายวันปัจจุบัน"
    },
    "drawdownLoss": {
      "drawdownTitle": "การลดลงสูงสุด",
      "currentTotalLossTitle": "ขาดทุนรวมปัจจุบัน"
    },
    "summary": {
      "title": "สรุป",
      "market": {
        "Forex": "การประเมิน Forex",
        "Futures": "การประเมิน Futures"
      }
    },
    "months": {
      "jan": "ม.ค.",
      "feb": "ก.พ.",
      "mar": "มี.ค.",
      "apr": "เม.ย.",
      "may": "พ.ค.",
      "jun": "มิ.ย.",
      "jul": "ก.ค.",
      "aug": "ส.ค.",
      "sep": "ก.ย.",
      "oct": "ต.ค.",
      "nov": "พ.ย.",
      "dec": "ธ.ค."
    },
    "dateRange": "<b>เริ่มต้นเมื่อ: </b>{from} ",
    "totalDays": "<b>สิ้นสุดเมื่อ: </b>{to} (คุณมีระยะเวลาประเมิน {days} วัน)",
    "brokerAccount": "<b>บัญชีที่เข้าร่วม: </b>{broker} {identifier}",
    "btnRestart": "เริ่มการจำลองใหม่",
    "btnGetChallenge": "รับความท้าทายนี้",
    "btnCreateAcc": "สร้างบัญชี",
    "btnGoToVendor": "ไปยังการประเมินจริงที่ {vendor}",
    "btnBackToTest": "กลับไปยังการจำลองของฉัน",
    "or": "หรือ",
    "alreadyHasAcc": "หากคุณมีบัญชี Swiset อยู่แล้ว",
    "login": "เข้าสู่ระบบ"
  },
  "vi": {
    "titles": {
      "WINNER": "Bạn đã đạt mục tiêu của mô phỏng",
      "DISQUALIFIED": "Bạn đã thất bại trong mô phỏng này",
      "ABANDONED": "Bạn đã từ bỏ mô phỏng này",
      "PAUSED": "Bạn đã tạm dừng mô phỏng này"
    },
    "target": {
      "targetTitle": "Số dư mục tiêu",
      "currentProfitTitle": "Số dư hiện tại"
    },
    "dailyLoss": {
      "dailyLossTitle": "Lỗ tối đa hàng ngày",
      "todayLossTitle": "Lỗ hàng ngày hiện tại"
    },
    "drawdownLoss": {
      "drawdownTitle": "Sụt giảm tối đa",
      "currentTotalLossTitle": "Tổng lỗ hiện tại"
    },
    "summary": {
      "title": "Tóm tắt",
      "market": {
        "Forex": "Đánh giá Forex",
        "Futures": "Đánh giá Hợp đồng tương lai"
      }
    },
    "months": {
      "jan": "Thg 1",
      "feb": "Thg 2",
      "mar": "Thg 3",
      "apr": "Thg 4",
      "may": "Thg 5",
      "jun": "Thg 6",
      "jul": "Thg 7",
      "aug": "Thg 8",
      "sep": "Thg 9",
      "oct": "Thg 10",
      "nov": "Thg 11",
      "dec": "Thg 12"
    },
    "dateRange": "<b>Bắt đầu từ: </b>{from} ",
    "totalDays": "<b>Kết thúc vào: </b>{to} (bạn có {days} ngày đánh giá)",
    "brokerAccount": "<b>Tài khoản tham gia: </b>{broker} {identifier}",
    "btnRestart": "Bắt đầu mô phỏng mới",
    "btnGetChallenge": "Nhận thử thách này",
    "btnCreateAcc": "Tạo tài khoản",
    "btnGoToVendor": "Chuyển đến đánh giá thực tế tại {vendor}",
    "btnBackToTest": "Quay lại mô phỏng của tôi",
    "or": "hoặc",
    "alreadyHasAcc": "Nếu bạn đã có tài khoản Swiset",
    "login": "đăng nhập"
  },
  "zh": {
    "titles": {
      "WINNER": "您已达到模拟目标",
      "DISQUALIFIED": "您未通过此模拟",
      "ABANDONED": "您已放弃此模拟",
      "PAUSED": "您已暂停此模拟"
    },
    "target": {
      "targetTitle": "目标余额",
      "currentProfitTitle": "当前余额"
    },
    "dailyLoss": {
      "dailyLossTitle": "每日最大亏损",
      "todayLossTitle": "今日亏损"
    },
    "drawdownLoss": {
      "drawdownTitle": "最大回撤",
      "currentTotalLossTitle": "当前总亏损"
    },
    "summary": {
      "title": "摘要",
      "market": {
        "Forex": "外汇评估",
        "Futures": "期货评估"
      }
    },
    "months": {
      "jan": "1月",
      "feb": "2月",
      "mar": "3月",
      "apr": "4月",
      "may": "5月",
      "jun": "6月",
      "jul": "7月",
      "aug": "8月",
      "sep": "9月",
      "oct": "10月",
      "nov": "11月",
      "dec": "12月"
    },
    "dateRange": "<b>开始时间：</b>{from} ",
    "totalDays": "<b>结束时间：</b>{to}（评估期为 {days} 天）",
    "brokerAccount": "<b>参与账户：</b>{broker} {identifier}",
    "btnRestart": "开始新的模拟",
    "btnGetChallenge": "接受此挑战",
    "btnCreateAcc": "创建账户",
    "btnGoToVendor": "前往 {vendor} 进行真实评估",
    "btnBackToTest": "返回我的模拟",
    "or": "或",
    "alreadyHasAcc": "如果您已有 Swiset 账户",
    "login": "登录"
  }

}
  </i18n>